import Api from './api'

// Admin_Project_Api client service. Wraps the JWT-attaching Api_Client
// (see ./api) so every request carries the session bearer token, and maps
// onto the server routes mounted under /api/administration/projects
// (all behind the existing isAuthenticated middleware). Requirement 1.3.
export default {
  // List the managed (non-proposal) projects for the Project_List,
  // ordered by ascending display_order.
  list () {
    return Api().get('administration/projects')
  },

  // Fetch a single project by id for the Project_Editor load.
  get (id) {
    return Api().get(`administration/projects/${id}`)
  },

  // Create a new project from the submitted field values.
  create (project) {
    return Api().post('administration/projects', project)
  },

  // Update an existing project's supplied fields.
  update (id, project) {
    return Api().put(`administration/projects/${id}`, project)
  },

  // Toggle a project's show_on_website state.
  setVisibility (id, showOnWebsite) {
    return Api().patch(`administration/projects/${id}/visibility`, { show_on_website: showOnWebsite })
  },

  // Persist a new display order for the managed projects. `desiredIdOrder`
  // is the array of project ids in the requested arrangement.
  reorder (desiredIdOrder) {
    return Api().put('administration/projects/reorder', { desiredIdOrder })
  },

  // Set or replace a project's image. Accepts either a JSON body with an
  // `imageUrl` (hosted URL) or a multipart FormData upload; an optional
  // axios config lets callers set the appropriate Content-Type/headers for
  // file uploads.
  setImage (id, payload, axiosConfig) {
    return Api().put(`administration/projects/${id}/image`, payload, axiosConfig)
  },

  // Remove a project's image, clearing its image_reference.
  removeImage (id) {
    return Api().delete(`administration/projects/${id}/image`)
  },

  // Delete a project.
  remove (id) {
    return Api().delete(`administration/projects/${id}`)
  }
}
